import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Button from '../Button/Button';
import styles from './SessionExpiredToast.module.css';

const AUTO_REDIRECT_MS = 6000;

function SessionExpiredToast() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    function handleExpired() {
      if (location.pathname === '/login') return;
      setVisible(true);
    }
    window.addEventListener('auth:sessionExpired', handleExpired);
    return () => window.removeEventListener('auth:sessionExpired', handleExpired);
  }, [location.pathname]);

  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => goToLogin(), AUTO_REDIRECT_MS);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  function goToLogin() {
    setVisible(false);
    navigate('/login', { replace: true });
  }

  if (!visible) return null;

  return (
    <div className={styles.toast} role="alert">
      <span className={styles.message}>Your session has expired. Please log in again.</span>
      <Button variant="primary" size="sm" fullWidth={false} onClick={goToLogin}>
        Log in
      </Button>
    </div>
  );
}

export default SessionExpiredToast;
